// Custom event system for real-time updates
export const EVENTS = {
  NOTIFICATION_UPDATE: 'notification_update'
};

const listeners = new Map();
const listenerRefs = new WeakMap();

export const addListener = (eventName, callback) => {
  if (!listeners.has(eventName)) {
    listeners.set(eventName, new Set());
  }
  
  // Remove any existing instance of this callback
  if (listenerRefs.has(callback)) {
    const existingRef = listenerRefs.get(callback);
    listeners.get(eventName).delete(existingRef);
  }
  
  // Create a new ref for this callback
  const callbackRef = async () => {
    try {
      await callback();
    } catch (error) {
      console.error('Error in event listener:', error);
    }
  };
  
  // Store the ref so we can clean it up later
  listenerRefs.set(callback, callbackRef);
  listeners.get(eventName).add(callbackRef);
};

export const removeListener = (eventName, callback) => {
  if (!listeners.has(eventName)) return;
  if (!listenerRefs.has(callback)) return;
  
  const callbackRef = listenerRefs.get(callback);
  listeners.get(eventName).delete(callbackRef);
  listenerRefs.delete(callback);
};

export const emitEvent = (eventName) => {
  console.log('Emitting event:', eventName);
  if (!listeners.has(eventName)) return;
  
  // Convert to array to avoid issues with Set modification during iteration
  const currentListeners = Array.from(listeners.get(eventName));
  currentListeners.forEach(callback => callback());
};
